module.exports = __webpack_public_path__ + "img/trophy_0003_flag.86a52c35.png";